import { CARE_ORDER_BABY_TYPE, } from '@/interface/domain/careOrderBaby';
import { EXTRA_NOTE_LIST_TEMPLATE } from '../../config/extraNoteList';
import { HOME_CARE_TITLE, NO_TUBE_OPTION } from '../../config/option';
export class CareOrderBabyFormForCareOrderBabyInitDConverter {
    #careOrderBabyForm;
    constructor(careOrderBabyForm) {
        this.#careOrderBabyForm =
            careOrderBabyForm;
    }
    get data() {
        const careOrderBabyInitParams = {
            initialType: this.#careOrderBabyForm.initialType,
            isAsap: this.#careOrderBabyForm.isAsap,
            timeSlotList: this.#getTimeSlotList(),
            patient: {
                gender: this.#careOrderBabyForm.gender,
                height: this.#careOrderBabyForm.height,
                weight: this.#careOrderBabyForm.weight,
                age: this.#careOrderBabyForm.age,
            },
            servedItem: this.#careOrderBabyForm.servedItem,
            symptom: this.#careOrderBabyForm.symptom,
            tube: this.#getTube(),
            requiredGender: this.#careOrderBabyForm.requiredGender,
            hospitalBed: this.#careOrderBabyForm.hospitalBed,
            lang: this.#careOrderBabyForm.lang,
            notes: this.#careOrderBabyForm.notes,
            extraNoteList: this.#getExtraNoteList(),
            contact: {
                name: this.#careOrderBabyForm.contactName,
                gender: this.#careOrderBabyForm.contactGender,
                phone: this.#careOrderBabyForm.contactPhone,
                ...(this.#careOrderBabyForm.contactEmail && {
                    email: this.#careOrderBabyForm.contactEmail,
                }),
            },
            hospital: this.#careOrderBabyForm.hospitalObj,
        };
        return careOrderBabyInitParams;
    }
    #getTimeSlotList() {
        const initialType = this.#careOrderBabyForm.initialType;
        if (initialType === CARE_ORDER_BABY_TYPE.ALL_DAY) {
            const timeSlotList = this.#careOrderBabyForm.timeSlotList;
            return timeSlotList;
        }
        const timeSlotList = this.#careOrderBabyForm.timeSlotList;
        return timeSlotList;
    }
    #getExtraNoteList() {
        const hospitalBed = this.#careOrderBabyForm.hospitalBed;
        if (hospitalBed !== HOME_CARE_TITLE)
            return EXTRA_NOTE_LIST_TEMPLATE;
        const hospitalObj = this.#careOrderBabyForm.hospitalObj;
        const hospitalName = hospitalObj.name;
        const extraNoteForHomeCare = `⚠️ 請注意：此為居家照顧案件，鄰近${hospitalName}`;
        return [extraNoteForHomeCare, ...EXTRA_NOTE_LIST_TEMPLATE];
    }
    #getTube() {
        const tube = this.#careOrderBabyForm.tube;
        const processedTube = tube.filter((item) => item !== NO_TUBE_OPTION.title);
        return processedTube;
    }
}
